import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setAuthToken] = useState(() => !!sessionStorage.getItem('userId'));

  const [userId, setUserId] = useState(() => sessionStorage.getItem('userId'));
  const [userType, setUserType] = useState(() => sessionStorage.getItem('userType'));
  const [constabulary, setConstabulary] = useState(() => sessionStorage.getItem('constabulary'));
  const [msiFile, setMsiFile] = useState(() => sessionStorage.getItem('msiFile'));
  const [msiUrl, setMsiUrl] = useState(() => sessionStorage.getItem('msiUrl'));
  const [macPack, setMacPack] = useState(() => sessionStorage.getItem('macPack'));
  const [androidApk, setAndroidApk] = useState(() => sessionStorage.getItem('androidApk'));
  const [groupId, setGroupId] = useState(() => {
    const v = sessionStorage.getItem('groupId');
    return v ? Number(v) : null;
  });
  const [android, setAndroid] = useState(() => {
    const v = sessionStorage.getItem('android');
    return v === null ? null : v === 'true';
  });
  const [chromeUrl, setChromeUrl] = useState(() => sessionStorage.getItem('chromeUrl'));
  const [forcePrefix, setForcePrefix] = useState(() => sessionStorage.getItem('forcePrefix'));

  const navigate = useNavigate();

  useEffect(() => {
    if (!token && window.location.pathname !== '/login') {
      navigate('/login');
    }
  }, [token, navigate]);

  const login = (username) => {
    if (!username) {
      logout();
      return;
    }

    sessionStorage.setItem('userId', username);
    setUserId(username);

    setAuthToken(true); // "logged in"
  };

  const logout = async () => {
    try {
      sessionStorage.clear();

      setAuthToken(false);
      setUserId(null);
      setUserType(null);
      setConstabulary(null);
      setMsiFile(null);
      setMsiUrl(null);
      setMacPack(null);
      setAndroidApk(null);
      setGroupId(null);
      setAndroid(null);
      setChromeUrl(null);
      setForcePrefix(null);

      navigate('/login');
    } catch (error) {
      console.error('Error logging out', error);
    }
  };

  useEffect(() => {
    if (chromeUrl) {
      sessionStorage.setItem('chromeUrl', chromeUrl);
    } else {
      sessionStorage.removeItem('chromeUrl');
    }

    if (msiFile) {
      sessionStorage.setItem('msiFile', msiFile);
    } else {
      sessionStorage.removeItem('msiFile');
    }

    if (msiUrl) {
      sessionStorage.setItem('msiUrl', msiUrl);
    } else {
      sessionStorage.removeItem('msiUrl');
    }

    if (macPack) {
      sessionStorage.setItem('macPack', macPack);
    } else {
      sessionStorage.removeItem('macPack');
    }

    if (androidApk) {
      sessionStorage.setItem('androidApk', androidApk);
    } else {
      sessionStorage.removeItem('androidApk');
    }

    if (constabulary) {
      sessionStorage.setItem('constabulary', constabulary);
    } else {
      sessionStorage.removeItem('constabulary');
    }

    if (forcePrefix) {
      sessionStorage.setItem('forcePrefix', forcePrefix);
    } else {
      sessionStorage.removeItem('forcePrefix');
    }

    if (groupId != null) {
      sessionStorage.setItem('groupId', String(groupId));
    } else {
      sessionStorage.removeItem('groupId');
    }

    if (android != null) {
      sessionStorage.setItem('android', android ? 'true' : 'false');
    } else {
      sessionStorage.removeItem('android');
    }
  }, [
    chromeUrl,
    msiFile,
    macPack,
    androidApk,
    constabulary,
    msiUrl,
    forcePrefix,
    groupId,
    android,
  ]);

  return (
    <AuthContext.Provider
      value={{
        token,          // boolean "isAuthenticated"
        setAuthToken,
        userId,
        setUserId,
        login,
        logout,
        userType,
        setUserType,
        setConstabulary,
        setMsiFile,
        setMsiUrl,
        setMacPack,
        setAndroidApk,
        setGroupId,
        setAndroid,
        setChromeUrl,
        setForcePrefix,
        constabulary,
        msiFile,
        msiUrl,
        macPack,
        androidApk,
        groupId,
        android,
        chromeUrl,
        forcePrefix,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
